import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ReauthenticationDialog } from 'shared/components'
import { isExtendingSessionVar, useSessionEndCountdown } from 'shared/session'
import SessionEndCountdown from './SessionEndCountdown'

interface SessionExtensionDialogProps {
  onClose: () => void
}

// The reauthentication gives the token a new auth time, which starts a new
// session. The expiry is held meanwhile, see useIsSessionExpiryPaused.
const SessionExtensionDialog = ({ onClose }: SessionExtensionDialogProps) => {
  const { t } = useTranslation()
  const secondsUntilSignOut = useSessionEndCountdown()

  useEffect(() => {
    isExtendingSessionVar(true)
    return () => {
      isExtendingSessionVar(false)
    }
  }, [])

  return (
    <ReauthenticationDialog
      title={t('extendSession')}
      message={t('extendSessionMessage')}
      warning={
        secondsUntilSignOut !== null ? (
          <SessionEndCountdown secondsLeft={secondsUntilSignOut} />
        ) : undefined
      }
      onClose={onClose}
      onReauthenticated={onClose}
    />
  )
}

export default SessionExtensionDialog
